module.exports = __webpack_public_path__ + "static/media/lake_at_sunset_small.68aa4058.jpg";